import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import { getDivisionCodes } from "../../api";
import type { DivisionCodeItem } from "../../types/division-code";

type DivisionSelectProps = {
  prefCode: string[] | null;
  changedValue: (value: string | null) => void;
};

export default function DivisionSelect({
  prefCode,
  changedValue,
}: DivisionSelectProps) {
  const [divisions, setDivisions] = useState<DivisionCodeItem[]>([]);
  const [selectedValue, setSelectedValue] = useState<DivisionCodeItem | null>(
    null
  );

  const getPref = async () => {
    if (Array.isArray(prefCode) && prefCode.length === 1) {
      setSelectedValue(null);
      changedValue(null);
      try {
        const response = await getDivisionCodes({
          pref_code: prefCode[0],
          order: null,
          sort: null,
          page: 1,
        });
        if (response.status !== "ok") {
          return;
        }
        const data = response.m_division_codes;
        if (data) {
          setDivisions(data);
        } else {
          console.error("ヒットする地区コード情報なし");
        }
      } catch (error) {
        console.error("API呼び出しエラー", error);
      }
    } else {
      setDivisions([]);
      setSelectedValue(null);
      changedValue(null);
    }
  };

  useEffect(() => {
    getPref();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefCode]);

  return (
    <Autocomplete
      limitTags={2}
      fullWidth
      size="small"
      options={divisions}
      value={selectedValue}
      getOptionLabel={(division) => division.full_name ?? division.city_name}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      renderInput={(params) => <TextField {...params} label="地域選択" />}
      onChange={(_event, newValues) => {
        setSelectedValue(newValues);
        changedValue(newValues?.code ?? null);
      }}
    />
  );
}
